import React from 'react';
import { CreateTeamForm } from '../../components/teams/CreateTeamForm';

const CreateTeamPage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <CreateTeamForm />
    </div>
  );
};

export default CreateTeamPage; 